/* @jsx h */
import { defineComponent, h, ref } from "vue";
import { LemmonModal, useLocalization } from "@lemmonhq/uikit";

export type NewSupplier = {
  name: string;
  email: string | null;
  phone: string | null;
  vat_number: string | null;
};

type Props = {
  saving: boolean;
  onClose: () => void;
  onAdd: (supplier: NewSupplier) => void;
};

export const AddSupplierModal = defineComponent<Props>({
  name: "AddSupplierModal",
  props: ["saving", "onClose", "onAdd"],
  setup(props) {
    const { t } = useLocalization();
    const name = ref("");
    const email = ref("");
    const phone = ref("");
    const vat = ref("");

    const field = (labelKey: string, model: typeof name, type = "text") => (
      <label class="block">
        <span class="mb-1 block text-sm font-medium">{t(labelKey)}</span>
        <input type={type} class="input input-bordered w-full" v-model={model.value} />
      </label>
    );

    return () => (
      <LemmonModal
        title={t("inventory.suppliers.add_title")}
        onClose={props.onClose}
        renderButtons={() => (
          <div class="border-t p-4">
            <div class="flex justify-between gap-2">
              <button class="btn btn-neutral" onClick={() => props.onClose()}>
                {t("general.words.cancel")}
              </button>
              <button
                class="btn btn-primary"
                disabled={!name.value.trim() || props.saving}
                onClick={() =>
                  props.onAdd({
                    name: name.value.trim(),
                    email: email.value.trim() || null,
                    phone: phone.value.trim() || null,
                    vat_number: vat.value.trim() || null,
                  })
                }
              >
                {t("inventory.suppliers.add")}
              </button>
            </div>
          </div>
        )}
      >
        <div class="space-y-4 p-6">
          {field("inventory.suppliers.col_name", name)}
          {field("inventory.suppliers.col_email", email, "email")}
          {field("inventory.suppliers.col_phone", phone, "tel")}
          {field("inventory.suppliers.col_vat", vat)}
        </div>
      </LemmonModal>
    );
  },
});
